import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=3d34a1f3&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=ts&"
export * from "./CustomerList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=3d34a1f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34a1f3",
  null
  
)

export default component.exports